var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"app-logo",attrs:{"src":"https://res.cloudinary.com/dv5har4fh/image/upload/v1609858537/StickerCode/beta_logo.png","width":"166","height":"40","alt":"StickerCode logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }